import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-vehicle-support-doc',
    templateUrl: './vehicle-support-doc.component.html',
    styleUrls: ['./vehicle-support-doc.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VehicleSupportDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
